// import { Link, useHistory } from 'react-router-dom';
import ImageGallery from '../components/projectGallery/imageGallery'
import FooterComp from '../components/FooterComp'
import profileImage from '../static/Images/tempDamian.webp'
import TechnicalSkills from '../components/TechnicalSkills'
import Education from '../components/Education'
import Projects from '../components/Projects'
import '../theme/core.css'
import { BgImage50 } from '../styledComponents/backgroundStyled'
import { Gap170, GlobalContainer, Gap50, AboutViewText, ProfileAboutStyled, ProfileStyled, ProfileImageContainer, ProfileImageStyled, ProfileImageBackBorderStyled, TextBorderStyled } from '../styledComponents/globalStyled'
export default function Home() {



    // useEffect(() => {
    //     var sidenav: any = document.getElementById("sidenav");
    //     var sticky = sidenav.offsetTop - 300;
    //     setoffset(sidenav.offsetTop - 300)

    //     window.onscroll = function () { myFunction() };
    //     console.log(offset)
    //     function myFunction() {
    //         if (window.pageYOffset >= sticky) {
    //             sidenav.classList.add("sticky")
    //         } else {
    //             sidenav.classList.remove("sticky");
    //         }
    //     }
    // }, [offset])

    return (
        <>

            {/* <div className="shark-2"> */}

            {/* </div> */}
            <BgImage50>
                <ProfileStyled>
                    <TextBorderStyled>Damian Raymond Dowie</TextBorderStyled><br /><br /><br />
                    <TextBorderStyled>Game Designer and Developer</TextBorderStyled><br /><br /><br />
                    <TextBorderStyled>Full Stack Developer</TextBorderStyled><br /><br /><br />
                    <ProfileImageContainer>
                        <ProfileImageStyled src={profileImage} alt="Damian" />
                    </ProfileImageContainer>

                </ProfileStyled>
            </BgImage50>
            <ProfileImageBackBorderStyled />
            {/* <div className="sticky" >
                <ul className="item-name">
                    <h1 >About Me</h1>
                    <h1 >TechnicalSkills</h1>

                    <h1 >Projects</h1>
                    <h1 >Education</h1>

                    <h1 >Games Gallery</h1>
                </ul>

            </div> */}
            <Gap170 />
            <ProfileAboutStyled>About Me</ProfileAboutStyled>
            <AboutViewText> I am a dedicated and self-motivated software developer, specializing in game development and Android app programming. Proficient in languages such as C#, C++, and JavaScript, I have garnered experience in game development frameworks, including Unity and Unreal, and possess a solid foundation in object-oriented programming (OOP) principles. Additionally, my skill set extends to 3D modeling using Blender.

                With a commitment to collaborative development practices, I have effectively utilized GitHub for version control, facilitating seamless cooperation with other developers. Known for my strong communication skills and ability to excel in both independent and team-oriented tasks, I continually strive for excellence in project delivery.

                In my most recent role at Airlaforge, I served as a full-stack developer, contributing to the development of robust Android applications. Utilizing my expertise in JavaScript and TypeScript, I created APIs that seamlessly interfaced with custom-built MySQL database servers. This experience has allowed me to expand my capabilities and contribute to diverse and dynamic projects.
            </AboutViewText>
            <Gap50 />

            <GlobalContainer>

                <TechnicalSkills />
                <Projects />

                <Education />
                <ImageGallery />
            </GlobalContainer>

            <FooterComp />
        </>
    );
}
